// Lazy-loaded components for code splitting
const GroupList = () =>
    import(/* webpackChunkName: "group" */ "./pages/ListPage.vue");
const GroupDetail = () =>
    import(/* webpackChunkName: "group" */ "./pages/FormPage.vue");
const GroupIndex = () =>
    import(/* webpackChunkName: "group" */ "./pages/IndexPage.vue");
export default [
    {
        path: "/group",
        component: GroupIndex,
        redirect: "/group/list",
        name: "group",
        children: [
            {
                path: "list",
                component: GroupList,
                name: "group.list",
            },
            {
                path: "create",
                component: GroupDetail,
                name: "group.create",
                props: { create: true },
            },
            {
                path: "edit/:id",
                component: GroupDetail,
                name: "group.edit",
                props: { create: false },
            },
        ],
    },
];
